import {MetaMask} from '@web3-react/metamask';
import {
  useConnectEagerly,
  useConnector,
  useInitializeConnector,
  useSwitchChain,
} from '../hooks';
import {Web3ConnectionType} from '../types';
import {useCallback, useEffect} from 'react';
import {BaseConnectorProps} from './types';

export const Metamask = ({
  onStateUpdate,
  chainId,
  onConnectorUpdate,
  options,
}: BaseConnectorProps<MetaMask>) => {
  const connector = useInitializeConnector(
    Web3ConnectionType.METAMASK,
    useCallback(actions => {
      return new MetaMask({actions});
    }, [])
  );

  useEffect(() => {
    onConnectorUpdate(connector.connector);
  }, [connector.connector, onConnectorUpdate]);

  const state = useConnector(connector, onStateUpdate);

  useConnectEagerly(connector.connector, Web3ConnectionType.METAMASK);

  useSwitchChain(connector.connector, state, chainId);

  return null;
};
